import helpers from 'boot/helpers'
import { Vue3Mq } from 'vue3-mq'

export default ({ app }) => {
  app.use(Vue3Mq, {
    preset: 'tailwind',
  })
  app.use(helpers)
}
